import React, { useMemo } from 'react';
import { Layout } from 'fronton-react';
import { RootLayout } from 'common/components';
import { ConsultationSection } from 'remotes/consultation-section';
import { PromoBlock } from 'remotes/promo-block';
import { SpecialOffer } from 'remotes/special-offer';
import {
  FeaturesSection,
  GallerySection,
  HeaderSection,
  ProjectDevelopmentSection,
  StepsSection,
} from '../components';
import { EngineeringSystemTypeProps } from '../engineering-systems-types';
import { FILTER_GALLERY_LIST } from './components/gallery-section';
import { FilterServices } from './components/filter-services'
import {
  DEFAULT_CONSULTATION_SECTION_TITLE,
  DEFAULT_CONSULTATION_SUB_CHANNEL,
} from '../engineering-systems-constants';
import {
  FILTER_DESCRIPTION_WITH_WATER_ANALYSIS,
  FILTER_DESCRIPTION_WITHOUT_WATER_ANALYSIS,
  FILTER_HEADER_SECTION_CONFIG,
} from './components/header-section';
import {
  COMPOSITION_LIST_WITH_WATER_ANALYSIS,
  COMPOSITION_LIST_WITHOUT_WATER_ANALYSIS,
  FILTER_DEVELOPMENT_PROJECT,
} from './components/development-project-section';
import {
  FILTER_STEP_LIST_WITHOUT_WATER_ANALYSIS,
  FILTER_STEP_LIST_WITH_WATER_ANALYSIS,
} from './components/steps-section';
import { QuestionSection } from './components/question-section';
import {
  DEFAULT_DEVELOPMENT_PRICE,
  DEVELOPMENT_PRICE,
  FILTER_DEVELOPMENT_ID,
  FILTER_ELEMENT_BLOCK,
  FILTER_REGION_ID_LIST_WITH_PRICE_FOUR_THOUSAND,
  FILTER_SYSTEMS_CONSULTATION_TYPE,
  FILTER_SYSTEMS_PATH,
} from './filter-systems-constants';

/**
 * Вью страницы "Системы вентиляции"
 */
export const FilterSystems = ({
  consultationSectionRef,
  onConsultationSignupBtnClick,
  regionId,
}: EngineeringSystemTypeProps) => {
  const isRegionWithWaterAnalysis = useMemo(
    () => regionId && FILTER_REGION_ID_LIST_WITH_PRICE_FOUR_THOUSAND.includes(regionId),
    [regionId]
  );

  const serviceTypePrice = useMemo(() => {
    if (isRegionWithWaterAnalysis) {
      return { [FILTER_DEVELOPMENT_ID]: DEVELOPMENT_PRICE };
    }
    return { [FILTER_DEVELOPMENT_ID]: DEFAULT_DEVELOPMENT_PRICE };
  }, [isRegionWithWaterAnalysis]);

  const stepList = useMemo(() => {
    if (isRegionWithWaterAnalysis) {
      return FILTER_STEP_LIST_WITH_WATER_ANALYSIS;
    }
    return FILTER_STEP_LIST_WITHOUT_WATER_ANALYSIS;
  }, [isRegionWithWaterAnalysis]);

  const filterDescription = useMemo(() => {
    if (isRegionWithWaterAnalysis) {
      return FILTER_DESCRIPTION_WITH_WATER_ANALYSIS;
    }
    return FILTER_DESCRIPTION_WITHOUT_WATER_ANALYSIS;
  }, [isRegionWithWaterAnalysis]);

  const compositionList = useMemo(() => {
    if (isRegionWithWaterAnalysis) {
      return COMPOSITION_LIST_WITH_WATER_ANALYSIS;
    }
    return COMPOSITION_LIST_WITHOUT_WATER_ANALYSIS;
  }, [isRegionWithWaterAnalysis]);

  return (
    <RootLayout currentPage={FILTER_SYSTEMS_PATH}>
      <Layout>
        <HeaderSection
          headerConfig={{
            ...FILTER_HEADER_SECTION_CONFIG,
            description: filterDescription,
          }}
          onConsultationSignupBtnClick={onConsultationSignupBtnClick}
        />
        <FeaturesSection />
        <PromoBlock elementBlock={FILTER_ELEMENT_BLOCK} />
        <SpecialOffer onModalBtnClick={onConsultationSignupBtnClick} elementBlock={FILTER_ELEMENT_BLOCK} />
        <FilterServices
          elementBlock={FILTER_ELEMENT_BLOCK}
          onConsultationSignupBtnClick={onConsultationSignupBtnClick}
        />
        <StepsSection shortSteps={!isRegionWithWaterAnalysis} stepSectionList={stepList} />
        <ProjectDevelopmentSection
          elementBlock={FILTER_ELEMENT_BLOCK}
          onConsultationSignupBtnClick={onConsultationSignupBtnClick}
          projectDevelopmentInfo={{
            ...FILTER_DEVELOPMENT_PROJECT,
            compositionList,
          }}
          serviceTypePrice={serviceTypePrice}
        />
        <GallerySection
          elementBlock={FILTER_ELEMENT_BLOCK}
          galleryList={FILTER_GALLERY_LIST}
          onConsultationSignupBtnClick={onConsultationSignupBtnClick}
        />
        <ConsultationSection
          consultationType={FILTER_SYSTEMS_CONSULTATION_TYPE}
          elementBlock={FILTER_ELEMENT_BLOCK}
          elementText="Заявка на консультацию"
          sectionRef={consultationSectionRef}
          sectionTitle={DEFAULT_CONSULTATION_SECTION_TITLE}
          subChannel={DEFAULT_CONSULTATION_SUB_CHANNEL}
        />
        <QuestionSection elementBlock={FILTER_ELEMENT_BLOCK} />
      </Layout>
    </RootLayout>
  );
};
